import React, { useEffect, useState } from 'react';
import { SafeAreaView, StyleSheet, View, Text, ScrollView, Linking, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

const CreateChoice = ({ navigation }) => {
  const [userData, setUserData] = useState({});

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = () => {
    fetch('https://collabbayadmin.com/APIControllers/GetSessionData.php')
      .then(response => response.json())
      .then(data => setUserData(data))
      .catch(error => console.error('Error fetching user data: ', error));
  };


  const [brandListings, setBrandListings] = useState([]);

const fetchBrandListings = () => {
  fetch('https://collabbayadmin.com/APIControllers/FetchBrandListingsBySession.php')
    .then(response => response.json())
    .then(data => setBrandListings(data || []))
    .catch(error => {
      console.error('Error fetching brand listings:', error);
      setBrandListings([]);
    });
};


  const [isAuthenticated, setIsAuthenticated] = useState(false);

useEffect(() => {
  if (userData.Username) {
    checkUserSubscriptionStatus();
  }
}, [userData]);

const checkUserSubscriptionStatus = async () => {
  try {
    const response = await fetch('https://collabbayadmin.com/APIControllers/UserSubscriptionAuth.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (data.authenticated) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
  } catch (error) {
    console.error('Error checking subscription status:', error);
    setIsAuthenticated(false);
  }
};


  const handleQRCodeScan = () => {
    Linking.openURL('https://collabbayadmin.com/QR.html');
  };

  return (
    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fff' }}>
    
    <SafeAreaView
      style={[
        styles.container,
        { width: '100%', maxWidth: 600, alignSelf: 'center', backgroundColor: '#fff', flex: 1 },
      ]}
    >
      <ScrollView contentContainerStyle={styles.contentContainer}>
        <View style={styles.section}>

        <Text style={[styles.sectionHeader, { 
  backgroundColor: 'black', 
  color: 'white', 
  padding: 10, 
  borderRadius: 15 
}]}>
  What would you like to do?
</Text>
          <View style={styles.cardRow}>
           


          <TouchableOpacity
  style={[styles.card, styles.yellowCard, { position: 'relative' }]}
  onPress={() => navigation.navigate('CreateBrandListing')}
>
  {/* Bell icon if no listings */}
  {userData.Username && brandListings?.length === 0 && (
    <View
      style={{
        position: 'absolute',
        top: 10,
        left: 10,
        backgroundColor: 'black',
        borderRadius: 12,
        padding: 4,
        elevation: 3, // slight shadow
        zIndex: 10,
      }}
    >
      <Ionicons
        name="notifications-outline"
        size={16}
        color="white"
      />
    </View>
  )}

  <Ionicons name="pricetag" size={40} color="#000" />
  <Text style={[
    styles.cardTitle,
    styles.blackText,
    {
      color: 'black',
      padding: 10,
      borderRadius: 10,
      width: '70%',
      textAlign: 'center',
      alignSelf: 'center',
    }
  ]}>
    Create an offer listing
  </Text>
</TouchableOpacity>


            <TouchableOpacity
              style={[styles.card, styles.yellowCard]}
              onPress={() => navigation.navigate('BrandCreateInviteLink')}
            >
              <Ionicons name="person-add-outline" size={40} color="black" />
              <Text 
  style={[
    styles.cardTitle, 
    styles.blackText, 
    { 
      color: 'black', 
      padding: 10, 
      borderRadius: 10, 
      width: '70%', 
      textAlign: 'center', 
      alignSelf: 'center'
    }
  ]}
>
  Invite an influencer to your venue
</Text>
            </TouchableOpacity>
          </View>
        </View>

        <View style={{ marginTop: 30, width: '100%' }}>
  <TouchableOpacity
    style={styles.tipsCard}
    onPress={() => Linking.openURL('https://collabbayadmin.com/Guide')}
  >
    <Ionicons
      name="information-circle-outline"
      size={24}
      color="black"
      style={{ marginRight: 10 }}
    />
    <Text style={styles.tipsText}>
      Before you post an offer...{'\n'}
      <Text style={{ fontWeight: 'bold' }}>Check out these tips</Text>
    </Text>
  </TouchableOpacity>
</View>



      </ScrollView>

      <View style={styles.footer}>
      <TouchableOpacity
  style={styles.footerIcon}
  onPress={() => {
    if (!userData.Username) {
      // Not logged in — do nothing
      return;
    }

    if (!isAuthenticated) {
      Linking.openURL('https://collabbayadmin.com/subscribe');
    } else {
      navigation.navigate('BrandActivityFeed');
    }
  }}
>
  <Ionicons name="chatbox-ellipses-outline" size={24} color="black" />

  {/* 🔒 Show lock if logged in and NOT subscribed */}
  {userData.Username && !isAuthenticated && (
    <View
      style={{
        position: 'absolute',
        top: -3,
        right: -3,
        backgroundColor: '#fdf05d',
        borderRadius: 10,
        padding: 2,
      }}
    >
      <Ionicons name="lock-closed-outline" size={12} color="black" />
    </View>
  )}
</TouchableOpacity>

        <TouchableOpacity
          style={styles.footerIcon}
          onPress={() => navigation.navigate('BusinessAccountPage')}
        >
          <Ionicons name="person" size={24} color="black" />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.footerIcon}
          onPress={() => navigation.navigate('BusinessHomepage')}
        >
          <Ionicons name="home" size={24} color="black" />
        </TouchableOpacity>
        <TouchableOpacity
  style={styles.footerIcon}
  onPress={() => {
    if (!userData.Username) {
      // Not logged in — do nothinga
      return;
    }

    if (!isAuthenticated) {
      Linking.openURL('https://collabbayadmin.com/subscribe');
    } else {
      navigation.navigate('CollabCalendar');
    }
  }}
>
  <Ionicons name="calendar" size={24} color="black" />

  {/* 🔒 Show lock if logged in and NOT subscribed */}
  {userData.Username && !isAuthenticated && (
    <View
      style={{
        position: 'absolute',
        top: -3,
        right: -3,
        backgroundColor: '#fdf05d',
        borderRadius: 10,
        padding: 2,
      }}
    >
      <Ionicons name="lock-closed-outline" size={12} color="black" />
    </View>
  )}
</TouchableOpacity>

        <TouchableOpacity
          style={styles.footerIcon}
          onPress={() => navigation.navigate('GuidedOfferSetup')}
        >
          <Ionicons name="add" size={24} color="black" />
        </TouchableOpacity>
      </View>
    </SafeAreaView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
  },
  contentContainer: {
    paddingHorizontal: 20,
    paddingTop: 40,
    paddingBottom: 80,
  },
  section: {
    marginTop: 20,
    width: '100%',
  },
  sectionHeader: {
    fontSize: 18,
    color: 'black',
    paddingLeft: 5,
    marginBottom: 20,
    fontWeight: 'bold',
    textAlign: 'left',
  },
  cardRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 10,
  },
  card: {
    flex: 1,
    height: 180,
    borderRadius: 15,
    justifyContent: 'center',
    alignItems: 'center',
    elevation: 4,
    paddingHorizontal: 10,
  },
  yellowCard: {
    backgroundColor: '#fdf05d',
  },
  blackCard: {
    backgroundColor: '#000',
  },
  cardTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 10,
    textAlign: 'center',
  },
  blackText: {
    color: '#000',
  },
  whiteText: {
    color: '#fff',
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: '#fff',
    position: 'sticky',
    bottom: 0,
    left: 0,
    right: 0,
    paddingVertical: 10,
  },
  footerIcon: {
    alignItems: 'center',
  },
  tipsCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f3f3f3',
    borderColor: '#ddd',
    borderWidth: 1,
    borderRadius: 20,
    padding: 15,
    width: '100%',
  },
  tipsText: {
    fontSize: 16,
    color: '#000',
    flex: 1, // ensures text uses remaining space
  },
  
});

export default CreateChoice;
